<template>
  <div>
    <HeadlineContainer headline="Legal Texts" :breadcrumbs="[{text: 'Legal Texts'}]">
      <router-link to="/legal-texts/create" class="btn btn-white">
        <i class="fa fa-plus"></i> Create
      </router-link>
    </HeadlineContainer>

    <div class="container">
      <LegalTextList/>
    </div>
  </div>
</template>

<script>
import HeadlineContainer from '@/components/Layout/HeadlineContainer'
import LegalTextList from '../../../components/Administration/LegalTexts/Panels/List'

export default {
  components: {HeadlineContainer, LegalTextList}
}
</script>
